import React, { useState, useEffect, useRef } from "react";

const StoneMenu = ({ x, y, visible, onClose, moveData, goToMove }) => {
  const [hoveredItem, setHoveredItem] = useState(null);

  let hoverTimeout;

  const handleMouseEnter = (item) => {
  // Clear any existing timeout to prevent multiple updates
  clearTimeout(hoverTimeout);

  // Set a timeout to update the hovered item after a delay
  hoverTimeout = setTimeout(() => {
    setHoveredItem(item);
    console.log("hover");
  }, 300); // Delay in milliseconds
  };

  const handleMouseLeave = () => {

    // Clear the timeout to prevent the hover action
    clearTimeout(hoverTimeout);
    
    setHoveredItem(null);
  };

  if (!visible) return null;

  return (
      <div
        className="stone-menu"
        onClick={onClose} // Close on click outside
        style={{
            position: "fixed",
            top: `${y}px`,
            left: `${x}px`,
          }}
      >
        <ul>
          <li 
          className="menu-item"
          onClick={() => console.log(moveData)}
          onMouseEnter={() => handleMouseEnter("submenu")}
          onMouseLeave={handleMouseLeave} >
            Inspect stone
            {hoveredItem === "submenu" && (
              !! moveData.moveData?.turn ? (
            <div class="stone-menu submenu">
              <p>Turn: {moveData.moveData.turn}</p>
              <p>Game score: {moveData.moveData.score.toFixed(2)}</p>
              <p>Move score: {moveData.moveData.moveDelta.toFixed(2)}</p>
              </div>
               ) : 
            <div class="stone-menu submenu">
              <p>Handicap stone</p>
            </div>
            )}
          </li>
          <li 
            className="menu-item"
            onClick={() => goToMove(moveData.moveData.turn-1)}> 
            Go to move
          </li>
          <li 
            className="menu-item"
            onClick={() => console.log("Modify position.")}>
            Modify position
          </li>
          <li 
            className="menu-item"
            onClick={() => console.log("Modify move number.")}>
            Modify move number
          </li>
        </ul>
      </div>
    );
  };

  export default StoneMenu